import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  NbComponentStatus,
  NbDialogRef,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbTagComponent,
  NbTagInputAddEvent,
  NbToastrService,
} from "@nebular/theme";
import * as _ from "lodash";
import { remove } from "lodash";
import { EMAIL_PATTERN } from "../../@auth/components/constants";
import { Employee } from "../../models/employee.model";

import { EmployeeService } from "../../services/employee.service";
import { DialogImagesUploadComponent } from "../dialog-images-upload/dialog-images-upload.component";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";

@Component({
  selector: "ngx-dialog-employee",
  templateUrl: "dialog-employee.component.html",
  styleUrls: ["dialog-employee.component.scss"],
})
export class DialogEmployeeComponent implements OnInit {
  @Input() header: string;
  @Input() mode: string;
  @Input() shopId: string;
  @Input() employee: Employee = new Employee();

  status: string = "0";
  trees: Set<string> = new Set([]);
  diaForm: FormGroup;
  submitted = false;
  loading = false;
  edited = false;
  imageURL = "";
  imagesUrl = [];
  menu = "info";

  constructor(
    protected ref: NbDialogRef<DialogEmployeeComponent>,
    private fb: FormBuilder,
    private employeeService: EmployeeService,
    private dialogService: NbDialogService,
    private toastrService: NbToastrService
  ) {}

  ngOnInit() {
    const fullNameValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const mobileValidators = [Validators.required];
    const stringValidators = [
      Validators.minLength(1),
      Validators.maxLength(500),
    ];
    const emailValidators = [Validators.pattern(EMAIL_PATTERN)];

    this.diaForm = this.fb.group({
      fullName: ["", fullNameValidators],
      description: ["", stringValidators],
      dob: [],
      gender: [],
      mobile: ["", mobileValidators],
      cardId: [],
      email: ["", emailValidators],
      address: ["", stringValidators],
      tax: [],
      isCounSellor: [],
      isSeller: [],
      isDeliverer: [],
    });

    if (!this.employee.dob) {
      this.employee.dob = new Date();
    }

    if (this.employee.tags && this.employee.tags.length > 0) {
      var trees = new Set([]);
      this.employee.tags.forEach(function (value) {
        trees.add(value);
      });
      this.trees = trees;
    } else {
      this.trees.add("KH");
    }
    if (!this.employee.sourceType || this.employee.sourceType == "") {
      this.employee.sourceType = "document";
    }
    if (!this.employee.gender) {
      this.employee.gender = "Khác";
    }
    if (this.employee.coverUrl && this.employee.coverUrl != "") {
      this.imageURL = this.employee.coverUrl;
    }
    if (this.employee.imagesUrl && this.employee.imagesUrl.length > 0) {
      this.imagesUrl = _.clone(this.employee.imagesUrl);
    }
    if (!this.employee.content) {
      this.employee.content = "";
    }
  }

  cancel() {
    if (this.edited) {
      this.ref.close(this.employee);
    } else {
      this.ref.close();
    }
  }

  selectMenu(value) {
    this.menu = value;
  }

  submit() {
    this.submitted = true;

    var tags: string[] = [];
    this.trees.forEach(function (item) {
      tags.push(item);
    });
    this.employee.tags = tags;
    this.employee.email = this.employee.email ? this.employee.email : "";
    this.employee.mobile = this.employee.mobile
      ? this.employee.mobile.replace(" ", "").trim()
      : "";

    this.employee.cardId = this.employee.cardId ? this.employee.cardId : "";
    this.employee.coverUrl = this.employee.coverUrl
      ? this.employee.coverUrl
      : "";
    this.employee.fullName = this.employee.fullName
      ? this.employee.fullName
      : "";
    if (this.employee.fullName != "") {
      this.employee.lastName = this.employee.fullName.split(" ")[0].trim();
      this.employee.firstName = this.employee.fullName
        .replace(this.employee.lastName, "")
        .trim();
    }
    if (this.employee.dob) {
      this.employee.dobYear = new Date(this.employee.dob).getFullYear();
      this.employee.dobMonth = new Date(this.employee.dob).getMonth() + 1;
      this.employee.dobDay = new Date(this.employee.dob).getDate();
    }

    this.employee.gender = this.employee.gender ? this.employee.gender : "Khác";
    this.employee.address = this.employee.address ? this.employee.address : "";
    this.employee.tax = this.employee.tax ? this.employee.tax : "";
    this.employee.description = this.employee.description
      ? this.employee.description
      : "";
    this.employee.tags = this.employee.tags ? this.employee.tags : [];
    this.employee.imagesUrl = this.employee.imagesUrl
      ? this.employee.imagesUrl
      : [];

    if (this.mode == "edit") {
      this.edit();
    } else {
      this.create();
    }
  }

  create() {
    this.loading = true;
    this.submitted = true;

    console.log("create:", this.employee);

    this.employeeService
      .create(this.employee)
      .then((data) => {
        this.employee = data;

        this.loading = false;
        this.submitted = false;

        this.ref.close(this.employee);
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
      });
  }

  edit() {
    this.loading = true;
    this.submitted = true;

    this.employeeService
      .update(this.employee)
      .then((data) => {
        this.loading = false;
        this.submitted = false;

        this.edited = true;
        this.ref.close(this.employee);
        this.showToast("success", "Cập nhật nhà cung cấp", "thành công");
      })
      .catch((err) => {
        this.loading = false;
        this.submitted = false;
        this.showToast("warning", "Cập nhật nhà cung cấp", "thất bại");
      });
  }

  delete(item: Employee) {
    this.dialogService
      .open(DialogYesNoPromptComponent, {
        context: {
          title: "Bạn có chắc xóa nhân viên này?",
        },
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.employeeService
            .delete(item.shopId, item.id)
            .then((result) => {
              this.loading = false;
              this.submitted = false;
              this.ref.close(this.employee);
            })
            .catch((err) => {
              this.loading = false;
              this.submitted = false;
            });
        }
      });
  }

  //Images
  openGallery() {
    this.dialogService
      .open(DialogImagesUploadComponent, {
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value) {
          this.addImage(value);
        }
      });
  }

  updateImage(imageUrl) {
    if (imageUrl && imageUrl != "") {
      this.employee.coverUrl = imageUrl;
      this.imageURL = imageUrl.replace("_400x400", "");
    }
  }
  removeCoverUrl() {
    this.employee.coverUrl = "";
    this.imageURL = "/assets/images/image-upload-bg.jpg";
  }

  addImage(obj) {
    let imageURL = obj.value;

    if (!this.employee.imagesUrl) {
      this.employee.imagesUrl = [];
    }
    this.employee.imagesUrl.push(imageURL);

    if (obj.isNew) {
      imageURL = imageURL.replace("_400x400", "");
    }
    this.imagesUrl.push(imageURL);
  }

  deleteImage(item) {
    remove(this.employee.imagesUrl, (el) => {
      return el == item;
    });
    remove(this.imagesUrl, (el) => {
      return el == item;
    });
  }

  //Tags
  onTagRemove(tagToRemove: NbTagComponent): void {
    this.trees.delete(tagToRemove.text);
  }

  onTagAdd({ value, input }: NbTagInputAddEvent): void {
    if (value) {
      this.trees.add(value);
    }
    input.nativeElement.value = "";
  }

  // control event
  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 2000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: false,
    };
    const titleContent = title ? `${title}` : "";

    this.toastrService.show(body, titleContent, config);
  }
}
